var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLockCircleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11630_17465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3722 20.6975H32.3784V16.38C32.3784 11.7594 28.6203 8 24.0003 8C19.3797 8 15.6203 11.7594 15.6203 16.38V20.6975H14.6284C13.1228 20.6975 11.8984 21.9225 11.8984 23.4275V33.8044C11.8984 37.2206 14.6778 40 18.0941 40H29.9078C33.3241 40 36.1034 37.2206 36.1034 33.8044V23.4275C36.1028 21.9225 34.8778 20.6975 33.3722 20.6975ZM17.1191 20.6975V16.38C17.1191 12.5856 20.2059 9.49875 24.0003 9.49875C27.7934 9.49875 30.8797 12.5856 30.8797 16.38V20.6975H17.1191Z",
    fill: "#FDC006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20.6973V39.9998H29.9075C33.3238 39.9998 36.1031 37.2204 36.1031 33.8041V23.4273C36.1031 21.9216 34.8781 20.6973 33.3731 20.6973H24Z",
    fill: "#EFBB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 25.8428C22.415 25.8428 21.125 27.1328 21.125 28.7184C21.125 30.0446 22.0281 31.1634 23.2512 31.494V34.1059C23.2512 34.5196 23.5869 34.8553 24.0006 34.8553C24.4144 34.8553 24.75 34.5196 24.75 34.1059V31.494C25.9731 31.1634 26.8763 30.0446 26.8763 28.7184C26.8763 27.1328 25.5863 25.8428 24.0006 25.8428Z",
    fill: "#465A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1198 16.38C17.1198 12.5856 20.2067 9.49875 24.0011 9.49875C27.7942 9.49875 30.8805 12.5856 30.8805 16.38V20.6975H32.3792V16.38C32.3792 11.7594 28.6211 8 24.0011 8C19.3805 8 15.6211 11.7594 15.6211 16.38V20.6975H17.1198V16.38Z",
    fill: "#465A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 25.8428H24V34.8553H24.0006C24.4144 34.8553 24.75 34.5196 24.75 34.1059V31.494C25.9731 31.1634 26.8763 30.0446 26.8763 28.7184C26.8763 27.1328 25.5862 25.8428 24.0006 25.8428Z",
    fill: "#40535B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 8H24V9.49875H24.0006C27.7938 9.49875 30.88 12.5856 30.88 16.38V20.6975H32.3787V16.38C32.3787 11.7594 28.6206 8 24.0006 8Z",
    fill: "#40535B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11630_17465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockCircleBg);
export default __webpack_public_path__ + "static/media/icon-lock-circle-bg.8a8de1c2d8e18fe2456f4452d2c57062.svg";
export { ForwardRef as ReactComponent };